import { render, staticRenderFns } from "./DefaultCostPage.vue?vue&type=template&id=e552c6b8&scoped=true"
import script from "./DefaultCostPage.vue?vue&type=script&lang=js"
export * from "./DefaultCostPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e552c6b8",
  null
  
)

export default component.exports